import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLinkedin = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="M24 23.985h-3.315v-5.188c0-1.237-.022-2.828-1.723-2.828-1.725 0-1.988 1.348-1.988 2.74v5.276h-3.312V13.317h3.178v1.459h.046c.442-.839 1.524-1.724 3.137-1.724 3.357 0 3.977 2.209 3.977 5.082zM9.924 11.86a1.923 1.923 0 1 1-.003-3.845 1.923 1.923 0 0 1 .003 3.845m1.658 12.125H8.263V13.317h3.319zM16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.164 16-16S24.837 0 16 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLinkedin);

export default ForwardRef;
